import { render } from "./ProjectDisplay.vue?vue&type=template&id=39246e5e&scoped=true&ts=true"
import script from "./ProjectDisplay.vue?vue&type=script&lang=ts"
export * from "./ProjectDisplay.vue?vue&type=script&lang=ts"

import "./ProjectDisplay.vue?vue&type=style&index=0&id=39246e5e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39246e5e"]])

export default __exports__